import { Directive, ElementRef, OnInit, Renderer2, inject, input } from '@angular/core';

@Directive({
  selector: 'svg[infoIcon]',
})
export class UiInfoIconDirective implements OnInit {
  fill = input<string>('currentColor');
  size = input<string>('20px');

  private el = inject(ElementRef<SVGSVGElement>);
  private renderer = inject(Renderer2);

  ngOnInit() {
    const svg = this.el.nativeElement;
    this.renderer.setAttribute(svg, 'title', 'Info');
    this.renderer.setAttribute(svg, 'viewBox', '0 0 20 20');
    this.renderer.setAttribute(svg, 'fill', this.fill());
    if (this.size && this.size() !== 'unset') {
      this.renderer.setStyle(svg, 'block-size', this.size());
    }
    const path = this.renderer.createElement('path', 'svg');
    this.renderer.setAttribute(
      path,
      'd',
      'M9.5 13.5h1V9.077h-1V13.5Zm.496-5.586a.536.536 0 0 0 .548-.54.536.536 0 0 0-.54-.548.537.537 0 0 0-.548.54.536.536 0 0 0 .54.548Zm.01 9.086a6.84 6.84 0 0 1-2.72-.547 7.056 7.056 0 0 1-2.234-1.504 7.058 7.058 0 0 1-1.505-2.232A6.838 6.838 0 0 1 3 9.992c0-.966.182-1.871.547-2.716a7.058 7.058 0 0 1 3.737-3.73A6.838 6.838 0 0 1 10.006 3c.967 0 1.872.182 2.717.547a7.087 7.087 0 0 1 3.73 3.731c.364.848.546 1.753.546 2.715a6.84 6.84 0 0 1-.547 2.721 7.056 7.056 0 0 1-3.731 3.74 6.795 6.795 0 0 1-2.715.546ZM10 16c1.667 0 3.083-.583 4.25-1.75C15.417 13.083 16 11.667 16 10c0-1.667-.583-3.083-1.75-4.25C13.083 4.583 11.667 4 10 4c-1.667 0-3.083.583-4.25 1.75C4.583 6.917 4 8.333 4 10c0 1.667.583 3.083 1.75 4.25C6.917 15.417 8.333 16 10 16Z',
    );
    this.renderer.appendChild(svg, path);
  }
}
